import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * LLM LLM v1 Configuration Validator
 * Validates LLM LLM configuration including prompt and output schema
 */
export const LLM_LLM_1_ConfigValidator = z.object({
    prompt: requiredString('Prompt is required'),
    outputSchema: z.record(z.string(), z.any()).optional()
});
//# sourceMappingURL=llm-llm-1.js.map